import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import loadingAnimation from "../loadingAnimation.json"
import Lottie from "lottie-react";
const Search = () => {
  const { query } = useParams();
  const [searchResults, setSearchResults] = useState({ movies: [], tvSeries: [] });
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true)

  const options = {
    method: "GET",
    headers: {
      accept: "application/json",
      Authorization:
        "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI0ZmZhM2UxNGQ0ZjMxOTg1NDk5NGE0ZjRjM2I0ODYwOCIsInN1YiI6IjY1NmNhNzlmZTM4YmQ4MDEzODU3MTRjZiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.dj5HiwpguntzVOpJVHY1sQ7emIQuESxWfM09tKqS9Ss",
    },
  };

  const fetchSearchResults = async (query) => {
    try {
      const response = await fetch(
        `https://api.themoviedb.org/3/search/multi?query=${encodeURIComponent(query)}&include_adult=true&language=en-US&page=1`,
        options
      );
      const data = await response.json();
      const allResults = data.results || [];

      const movies = allResults.filter(result => result.media_type === 'movie');
      const tvSeries = allResults.filter(result => result.media_type === 'tv');

      setSearchResults({ movies, tvSeries });
      setLoading(false)
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchSearchResults(query);
  }, [query]);
  
  if(loading){
    return <div className="flex items-center justify-center h-screen">
      <Lottie className="pl-20" animationData={loadingAnimation} height={50} width={50}></Lottie>
    </div>
  }
  return (
    <div className="bg-[#221F1F]">
      {/* Movies in Search Results */}
      <div>
        <div className="text-[#867d7d] font-sans font-bold p-3 text-left lg:text-white lg:font-poppins">
          Movies in Search Results
        </div>

        <div className="flex space-x-2 overflow-x-auto px-3 no-scrollbar">
          {searchResults.movies.map((movie) => (
            <img
              key={movie.id}
              className="w-40 rounded-sm hover:cursor-pointer"
              src={
                movie.poster_path
                  ? `https://image.tmdb.org/t/p/original/${movie.poster_path}`
                  : "https://cdn.dribbble.com/users/469978/screenshots/10198884/artboard_4x.jpg"
              }
              alt={movie.title}
              title={movie.title + " (" + (movie.release_date || '').slice(0, 4) + ")"}
              onClick={() => navigate(`/playvideo/movie/${movie.id}`)}
            />
          ))}
        </div>
      </div>

      {/* TV Series in Search Results */}
      <div>
        <div className="text-[#867d7d] font-sans font-bold p-3 text-left lg:text-white lg:font-poppins">
          TV Series in Search Results
        </div>
        <div className="flex space-x-2 overflow-x-auto px-3 no-scrollbar ">
          {searchResults.tvSeries.map((series) => (
            <img
              key={series.id}
              className="w-40 rounded-sm hover:cursor-pointer"
              src={
                series.poster_path
                  ? `https://image.tmdb.org/t/p/original/${series.poster_path}`
                  : "https://cdn.dribbble.com/users/469978/screenshots/10198884/artboard_4x.jpg"
              }
              alt={series.name}
              title={series.name + " (" + (series.first_air_date || '').slice(0, 4) + ")"}
              onClick={() => navigate(`/playvideo/tv/${series.id}`)}
            />
          ))}
        </div>
      </div>
      <div className="hidden lg:block text-xs my-3 text-gray-700 absolute bottom-1 left-1/2">Tip: Use Shift+Scroll to scroll horizontally</div>
    </div>
  );
};

export default Search;
